import React, { FC } from 'react';
import semverLt from 'semver/functions/lt';

import { runningInRNWebView, useReactNativeProps } from '@eika-infrastruktur/mobilbank-lib';
import { InfoCard } from '@eika/card';
import { Link, LinkType } from '@eika/link';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { EikaModal } from '../../components/EikaModal';
import { useConfig } from '../../defaultConfig';
import useTranslation from '../../hooks/useTranslation';
import { isIOS } from '../../utils/native/platform';
import getValidSemver from './getValidSemver';

import './ForceUpdateModal.scss';

const ForceUpdateModal: FC = () => {
    const translated = useTranslation();
    const { appVersion } = useReactNativeProps();
    const appVersionNormalized = getValidSemver(appVersion);
    const { minimumAppVersion, appStoreUpdateLink, googlePlayUpdateLink } = useConfig();

    if (runningInRNWebView && (!appVersionNormalized || semverLt(appVersionNormalized, minimumAppVersion))) {
        return (
            <EikaModal id="force-update-modal" open setOpen={() => null} hideCloseButton shouldExitOnEscape={false}>
                <InfoCard skipBackground>
                    <RichIcon type={RichIconTypes.KLOKKE} />
                    <InfoCard.TitleH2>{translated.forceUpdateModal.title}</InfoCard.TitleH2>
                    <p>{translated.forceUpdateModal.description}</p>
                    <Link
                        className="force-update-modal__link"
                        linkType={LinkType.BUTTON_STANDARD_POSITIVE}
                        href={isIOS() ? appStoreUpdateLink : googlePlayUpdateLink}
                    >
                        {translated.forceUpdateModal.buttonText}
                    </Link>
                </InfoCard>
            </EikaModal>
        );
    }

    return null;
};

export default ForceUpdateModal;
